import { createZustandStore } from 'zustand-x';

export const withErrorHandling = (editor) => {
  const errorStore = createErrorStore();
  editor.errorHandler = {
    errorStore,
    pushErrorMessage: (message) => {
      const error = { message };
      errorStore.set.pushError(error);
    },
    popErrorMessage: () => {
      errorStore.set.pop();
    },
  };

  return editor;
};

export const createErrorStore = () => {
  return createZustandStore('error')({ errors: [] })
    .extendActions((set, get) => ({
      pushError: (error) => {
        const errors = get.errors();
        set.errors([ ...errors, error ]);
      },
    }))
    .extendActions((set, get) => ({
      pop: () => {
        const errors = get.errors();
        const errLen = errors.length;
        const newErrors = errors.slice(1, errLen);
        set.errors(newErrors);
      },
    }))
    .extendSelectors((state, get) => ({
      top: () => {
        const errors = get.errors();
        if (errors.length > 0) return errors[0];
        return null;
      },
    }));
};

const tryCatchCallback =
  (callback, editor) =>
  (...args) => {
    try {
      return callback(...args);
    } catch (error) {
      // #TODO: Implement better wording for error message.
      editor.errorHandler.pushErrorMessage(
        `Your last action could not be completed.
        If you are pasting something, there may be something wrong with what was copied.
        Please try to continue in a different way.`);
      throw error;
    }
  };

export const withErrorReporting = (editor) => {
  Object.entries(editor).forEach(([key, value]) => {
    if (typeof value === 'function') {
      editor[key] = tryCatchCallback(value, editor);
    }
  });

  return editor;
};
